export const environment = {
  production: true,
  strapiEndpoint: 'https://zerowastestockholm.org/api',
  strapiGraphQl: 'https://zerowastestockholm.org/api',
  serverEndpoint: 'https://zerowastestockholm.org',
  googleClientId: '911558731036-0njvs9ghipphueic5qfsl1j1cus7th76.apps.googleusercontent.com',
  googleRecaptchaSiteKey: '6LfQfogbAAAAAM1tp4AnJeikq-NTbh3WJvcB3ZJ-',
  matomoEndpoint: '//zerowastestockholm.org/stats/'
};